const es = {
  nav_dashboard: 'Panel', nav_inventory: 'Inventario', nav_my_stock: 'Mi Stock',
  nav_containers: 'Contenedores', nav_requests: 'Solicitudes', nav_invoices: 'Facturas',
  nav_payments: 'Pagos', nav_settings: 'Configuración', nav_sign_out: 'Cerrar Sesión',
  nav_customers: 'Clientes', nav_employees: 'Personal', nav_tasks: 'Tareas',
  nav_scan: 'Escanear', nav_pricing: 'Precios', nav_price_quotes: 'Cotizaciones',
  nav_selection_orders: 'Pedidos de Selección',
  btn_save: 'Guardar', btn_cancel: 'Cancelar', btn_delete: 'Eliminar', btn_edit: 'Editar',
  btn_add: 'Agregar', btn_submit: 'Enviar', btn_approve: 'Aprobar', btn_reject: 'Rechazar',
  btn_search: 'Buscar', btn_confirm: 'Confirmar', btn_sign_in: 'Iniciar Sesión',
  btn_save_changes: 'Guardar Cambios',
  login_title: 'BIG STAR', login_subtitle: 'Gestión de Exportación de Vehículos',
  login_username: 'Nombre de usuario', login_email: 'Correo', login_password: 'Contraseña',
  login_remember: 'Recordarme', login_invalid: 'Credenciales inválidas',
  detail_make: 'Marca', detail_model: 'Modelo', detail_year: 'Año',
  detail_chassis: 'Número de Chasis', detail_color: 'Color', detail_mileage: 'Kilometraje',
  detail_condition: 'Condición', detail_status: 'Estado', detail_price: 'Precio', detail_fob: 'Precio FOB',
  status_available: 'Disponible', status_shipped: 'Enviado',
  status_delivered: 'Entregado', status_pending: 'Pendiente',
  vehicles: 'Vehículos', engines: 'Motores', parts: 'Repuestos', dashboard: 'Panel',
  add: 'Agregar', edit: 'Editar', save: 'Guardar', cancel: 'Cancelar', search: 'Buscar',
  noData: 'Sin datos', dash_welcome: 'Bienvenido, {name}',
  dash_total_fob: 'Valor FOB Total',
  dash_late_night: 'Buenas noches', dash_hello: 'Hola',
  dash_subtitle: 'Resumen de tu flota, repuestos y envíos entrantes — actualizado en tiempo real.',
  dash_local_time: 'HORA LOCAL', dash_status: 'ESTADO', dash_all_systems_live: 'Todos los sistemas activos',
  dash_view_recommendations: 'Ver recomendaciones', dash_my_stock: 'MI STOCK', dash_in_transit: 'EN TRÁNSITO',
  dash_units: 'unidades', dash_containers: 'contenedores', dash_browse_more: 'Ver más',
  dash_track_shipments: 'Rastrear envíos', dash_browse_inventory_start: 'Explora el inventario para empezar',
  dash_no_active_shipments: 'Sin envíos activos', dash_next_eta: 'Próxima llegada en', dash_days: 'días',
  dash_etas_confirming: 'Fechas de llegada en confirmación', dash_this_week: 'ESTA SEMANA',
  dash_arriving_soon: 'LLEGA PRONTO', dash_logistics: 'LOGÍSTICA', dash_active_shipments: 'Envíos activos',
  dash_view_all: 'Ver todos', dash_shipment_empty: 'Tu próximo envío aparecerá aquí cuando las unidades se carguen en un contenedor',
  dash_composition: 'COMPOSICIÓN', dash_stock_breakdown: 'Desglose de stock', dash_no_units_yet: 'Aún no hay unidades',
  dash_browse_to_build: 'Explora el inventario para construir tu stock',
  dash_for_you: 'PARA TI', dash_picked_based: 'Seleccionado según tu stock', dash_browse_all: 'Ver todo',
  dash_picking_units: 'Estamos seleccionando unidades para ti. Vuelve pronto o explora todo el inventario',
  dash_view_details: 'Ver detalles', dash_just_arrived: 'RECIÉN LLEGADO', dash_similar: 'SIMILAR AL TUYO',
  dash_today: 'Hoy', dash_tomorrow: 'Mañana',
};
export default es;
